import { updateLanguage } from '@/api/passenger'

const updatePassengerLanguage = (context, langCode) => {
  return updateLanguage(langCode).then((response) => {
    return response
  })
}

export default {
  updatePassengerLanguage
}
